import * as _ from 'lodash'

export const DEFAULTS = {
  unknown: require('./defaults/unknown.svg'),
  error: require('./defaults/error.svg')
}

export const ICONS = {
  dark: {
    visa: require('./dark/1.png'),
    master_card: require('./dark/2.png'),
    discover: require('./dark/14.png'),
    american_express: require('./dark/22.png'),
    unknown: DEFAULTS.unknown,
    error: DEFAULTS.error
  },
  light: {
    visa: require('./light/1.png'),
    master_card: require('./light/2.png'),
    discover: require('./light/14.png'),
    american_express: require('./light/22.png'),
    unknown: DEFAULTS.unknown,
    error: DEFAULTS.error
  }
}

export default ({ method = 'unknown', theme = 'dark' } = {}) => {
  method = _.chain(method).lowerCase().trim().snakeCase().value()
  return _.get(ICONS, [theme, method], DEFAULTS.unknown)
}
